import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Container, Typography } from '@mui/material';
import styles from './landingPage.module.css';
import { useTranslation } from 'react-i18next';
import logoDark from '../../assets/logo-dark.png';
import logoLight from '../../assets/logo-light.png';
import { useTheme } from '../../contexts/theme';
import { PublicFooter } from '../ui/footer/publicFooter.component';

export const LandingPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isDarkMode } = useTheme();

  const handleLoginClick = () => {
    navigate('/login');
  };

  const handleRegisterClick = () => {
    navigate('/register');
  };

  return (
    <Box className={styles.container}>
      <Container maxWidth="lg" className={styles.contentContainer}>
        <Box className={styles.heroSection}>
          <Box className={styles.logoContainer}>
            <img src={isDarkMode ? logoDark : logoLight} alt="Copigo Logo" className={styles.logo} />
          </Box>

          <Typography variant="h5" className={styles.subtitle}>
            {t('Office equipment rental, billing and service in one platform')}
          </Typography>

          <Box className={styles.featuresBox}>
            <Box className={styles.feature}>
              <Typography variant="h6" className={styles.featureTitle}>
                {t('Equipment and contracts')}
              </Typography>
              <Typography variant="body1" className={styles.featureText}>
                {t('Keep every leased device on a contract: where it stands, who uses it, what it costs and when the term ends.')}
              </Typography>
            </Box>

            <Box className={styles.feature}>
              <Typography variant="h6" className={styles.featureTitle}>
                {t('Meter readings')}
              </Typography>
              <Typography variant="body1" className={styles.featureText}>
                {t('Collect counter readings per device, keep their full history and catch the ones that do not add up.')}
              </Typography>
            </Box>

            <Box className={styles.feature}>
              <Typography variant="h6" className={styles.featureTitle}>
                {t('Settlements')}
              </Typography>
              <Typography variant="body1" className={styles.featureText}>
                {t('Bill each device by its counter at your own rates and let monthly settlements generate themselves.')}
              </Typography>
            </Box>
          </Box>

          <Box className={styles.actionsBox}>
            <Button
              variant="contained"
              color="primary"
              size="large"
              onClick={handleLoginClick}
              className={styles.actionButton}
            >
              {t('Log in')}
            </Button>
            <Button
              variant="outlined"
              color="primary"
              size="large"
              onClick={handleRegisterClick}
              className={styles.actionButton}
            >
              {t('Register')}
            </Button>
          </Box>
        </Box>
      </Container>
      <PublicFooter />
    </Box>
  );
};
